function getStartOfDayTimestamp(date) {
  if (!date || !(date instanceof Date)) {
    return null;
  }
  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0);
  return date.getTime() / 1000;
}

function getEndOfDayTimestamp(date) {
  if (!date || !(date instanceof Date)) {
    return null;
  }
  date.setHours(23);
  date.setMinutes(59);
  date.setSeconds(59);
  return date.getTime() / 1000;
}

function getAge(dateString) {
  // dateString is in the format of YYYY-MM-DD HH:MM:SS this function will return
  // the age of the date in the format of "1d" or "1h" or "1m" or "1s"
  const createdDate = new Date(dateString);
  const now = new Date();
  const diffMs = now - createdDate;
  const diffMinutes = Math.floor(diffMs / (1000 * 60));

  if (diffMinutes < 60) {
    return `${diffMinutes}m`;
  }
  const diffHours = Math.floor(diffMinutes / 60);
  if (diffHours < 24) {
    return `${diffHours}h`;
  }
  const diffDays = Math.floor(diffHours / 24);
  if (diffDays < 7) {
    return `${diffDays}d`;
  }
  const diffWeeks = Math.floor(diffDays / 7);
  if (diffWeeks < 5) {
    return `${diffWeeks}w`;
  }
  const diffMonths = Math.floor(diffDays / 30);
  if (diffMonths < 12) {
    return `${diffMonths}mo`;
  }
  const diffYears = Math.floor(diffMonths / 12);
  return `${diffYears}year${diffYears > 1 ? 's' : ''}`;
}

export { getAge, getStartOfDayTimestamp, getEndOfDayTimestamp };
